export default "__VITE_ASSET__BWgyFx7z__"